export type code = 'success' | 'warning' | 'error' | 'loading';

export function GetColor(code: code) {
  if (code === 'success') {
    return 'primary';
  } else if (code === 'warning') {
    return 'warning';
  } else if (code === 'error') {
    return 'error';
  } 
  return 'loading';
}
